import { Flex, FlexProps } from '@mantine/core';
import { IconArrowUpRight } from '@tabler/icons-react';
import * as React from 'react';
import { Link } from 'react-router-dom';

import s from './Customlink.module.scss';

type Props = FlexProps & {
  isArrow?: boolean;
  label?: React.ReactNode;
} & (
    | {
        as: 'link';
        href: string;
      }
    | {
        as: 'button';
        onClick: () => void;
      }
  );

const CustomLink: React.FC<Props> = ({ isArrow = true, label, ...props }) => {
  if (props.as === 'link') {
    return (
      <Link to={props.href} className={s.link}>
        <Flex p="0" align="center" c="indigo" {...props}>
          <span>{label}</span>
          {isArrow && <IconArrowUpRight size={20} />}
        </Flex>
      </Link>
    );
  }

  return (
    <Flex p="0" align="center" c="indigo" className={s.link} style={{ cursor: 'pointer' }} {...props}>
      <span>{label}</span>
      {isArrow && <IconArrowUpRight size={20} />}
    </Flex>
  );
};

export default CustomLink;
